import { CLAIMS_DELETE_STR } from "common/sf_strings";
import { MODE } from "helpers/sf_constants";
import { getPrimaryTextClass } from "helpers/sf_utils";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Card, CardBody, Col, Label, Row, Table } from "reactstrap";
import { addLeadViolation, deleteLeadViolation, updateLeadViolation } from "store/leads/lead_violations_actions";
import DeleteModal from "../DeleteModal";
import AddClaimModal from "../Modals/AddClaimModal";
import LeadDatePicker from "./LeadDatePicker";
import LeadEditDropdown from "./LeadEditDropdown";
import LeadEditDropdownForNumberFields from "./LeadEditDropdownForNumberFields";
import { deleteProspectViolation, updateProspectViolation } from "store/prospects/prospects_violations_actions";
import { addProspectViolation } from "store/prospects/actions";
import LeadDetailReadOnlyContext from "contexts/LeadDetailReadOnlyContext";
import { useContext } from "react";

const LeadClaims = (props) => {
    const isReadOnly = useContext(LeadDetailReadOnlyContext) || props?.isReadOnly;
    const [lead_data, setLeadData] = useState({})
    const [deleteClaimsModal, setDeleteClaimsModal] = useState({ action: false, claim: {} });
    const { lead_id } = useParams();
    const { leads } = useSelector(state => ({
        leads: state.Leads.leads,
    }));
    const dispatch = useDispatch();
    const [claimModalState, setClaimModalState] = useState({ active: null, values: null });
    let leadViolationUpdater = updateLeadViolation
    let leadViolationAdder = addLeadViolation
    let leadViolationDeleter = deleteLeadViolation
    if (props?.is_prospect) {
        leadViolationUpdater = updateProspectViolation;
        leadViolationAdder = addProspectViolation
        leadViolationDeleter = deleteProspectViolation
    }
    //Create a useeffect and get lead data from redux store from lead_id from useParams
    const getDriverNameFromApplicant = (applicant_id) => {
        if (lead_data?.lead_applicants?.length > 0) {
            const applicant = lead_data?.lead_applicants?.find(applicant => applicant.id === applicant_id);
            return applicant?.first_name + ' ' + applicant?.last_name;
        }
        return '--';
    }

    //Create a useeffect and get lead data from redux store from lead_id from useParams

    useEffect(() => {
        if (props?.lead_data) {
            setLeadData(props?.lead_data);
        }
    }, [leads, lead_id, props?.lead_data])

    const handleLaunchClaimModal = (active, values, mode) => {
        setClaimModalState({ active: active, values: values, mode: mode });
    }

    const onClickSaveClaim = (mode, values) => {
        if (mode === MODE.EDIT) {
            dispatch(leadViolationUpdater({ lead_violation: { ...values } }))
        } else {
            dispatch(leadViolationAdder({ ...values, violation_type_id: 3 }))
        }
        handleLaunchClaimModal(false, null)
    }

    // For Delete Claims Modal
    const launchdeleteClaimModal = (claim) => {
        setDeleteClaimsModal({ action: true, claim: claim });
    };

    const onClickClaimModal = (payload) => {
        dispatch(leadViolationDeleter({ id: payload?.claim?.id }));
        setDeleteClaimsModal({ action: false, claim: {} });
    };

    return (
        <React.Fragment>
            <DeleteModal
                deleteModalState={deleteClaimsModal}
                onDeleteClick={onClickClaimModal}
                textMessage={CLAIMS_DELETE_STR}
                onCloseClick={() => setDeleteClaimsModal({ action: false, claim: {} })}
                cancelButton
            />
            <AddClaimModal
                title={"Claim"}
                leadApplicants={lead_data?.lead_applicants || null}
                show={claimModalState}
                onClickSaveClaim={onClickSaveClaim}
                onCloseClick={() => handleLaunchClaimModal(false)}
            />
            <Card>
                <CardBody className="pt-0">
                    <Row>
                        <div className="px-0">
                            <Table className="mb-0 text-black">
                                {lead_data?.lead_violations?.map((violation, idx) =>
                                (
                                    <tbody id={idx === 0 ? 'primary_claim' : 'secondary_claim'}>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <Col className="d-flex align-items-center pt-1 my-2">
                                                    <i className={`bx fs-24 bx-car ${getPrimaryTextClass()}`} />
                                                    <div className="mx-2 fs-15 font-weight-semibold">
                                                        Claim #{idx + 1}
                                                    </div>
                                                    {!isReadOnly &&
                                                        <div className="ms-1 fs-13 text-sfblue font-weight-semibold align-self-end">
                                                            <a onClick={() => setClaimModalState({ active: true, mode: MODE.EDIT, values: violation })}>Edit</a>
                                                        </div>
                                                    }
                                                </Col>
                                            </td>
                                            <td></td>
                                            <td style={{ width: '33%' }}>
                                                {!isReadOnly &&
                                                    <Col className={`${getPrimaryTextClass()} pt-1 my-2 font-weight-semibold`}>
                                                        <div className="d-flex flex-row-reverse">
                                                            <a
                                                                className={`d-flex ${getPrimaryTextClass()}`}
                                                                onClick={() => launchdeleteClaimModal(violation)}
                                                            >
                                                                <i className="mdi mdi-close me-2" />
                                                                Remove
                                                            </a>
                                                        </div>
                                                    </Col>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Description
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            title='Description'
                                                            field={violation?.desc || '--'}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = violation?.id
                                                                data.desc = value
                                                                dispatch(leadViolationUpdater({ lead_violation: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Date
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadDatePicker
                                                            title='Date'
                                                            field={violation?.dt}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = violation?.id
                                                                data.dt = value
                                                                dispatch(leadViolationUpdater({ lead_violation: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Amount Paid
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdownForNumberFields
                                                            dollarFormatter={true}
                                                            title='Amount Paid'
                                                            field={violation?.paid_amount}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = violation?.id
                                                                data.paid_amount = value
                                                                dispatch(leadViolationUpdater({ lead_violation: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                ))}
                            </Table>
                        </div>
                        <div className="text-sfblue font-weight-semibold mt-4">
                            {!isReadOnly && <a onClick={() => handleLaunchClaimModal(true, null, MODE.CREATE)}>+ Add Claim</a>}
                        </div>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default LeadClaims